import {createReducer} from '@reduxjs/toolkit';
import {getProjects, getFeedbacks, getProfiles} from './actions';
import {ProjectInfoDto} from '../../../dto/ProjectInfoDto';
import {FeedbackDto} from '../../../dto/FeedbackDto';
import {ProjectProfiles} from '../typedef';

type InitialState = {
    projects: ProjectInfoDto[];
    feedbacks: FeedbackDto[];
    profiles: ProjectProfiles[];
};

const initialState: InitialState = {
    projects: [],
    feedbacks: [],
    profiles: []
};

export const feedbackOverview = createReducer(initialState, (builder) =>
    builder
        .addCase(getProjects.fulfilled, (state, action) => ({...state, projects: action.payload}))
        .addCase(getFeedbacks.pending, (state, action) => ({
            ...state,
            feedbacks: state.feedbacks.filter((el) => el.projectId !== action.meta.arg.projectId)
        }))
        .addCase(getFeedbacks.fulfilled, (state, action) => ({
            ...state,
            feedbacks: state.feedbacks.concat(action.payload)
        }))
        .addCase(getProfiles.pending, (state, action) => ({
            ...state,
            profiles: state.profiles.filter((el) => el.projectId !== action.meta.arg.projectId)
        }))
        .addCase(getProfiles.fulfilled, (state, action) => ({
            ...state,
            profiles: state.profiles.concat(action.payload)
        }))
);
